<template>
    <div>
        <form data-vv-scope="subject_with_mark">
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block" class="p-1">
                    <MultiselectCustom
                        endpoint="organizations/disciplines/search/"
                        prevEndpoint="organizations/disciplines/"
                        :prevCount="20"
                        name="discipline_subject"
                        search-object-endpoint="organizations/disciplines/"
                        search-key="name"
                        v-validate="'required'"
                        :placeholder="`${$t('discipline_subject_input')}*`"
                        v-model="subject.discipline"
                    />
                    <ValidateText
                        field="discipline_subject"
                        scope="subject_with_mark"
                        :error="errors"
                    />
                </div>
            </div>
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block" class="p-1">
                    <vs-input
                        :label-placeholder="`${$t('mark')}`"
                        v-validate="
                            'required|integer|min_value:0|max_value:150'
                        "
                        name="mark"
                        v-model="subject.score"
                        class="mt-8 flex-auto p-1 w-full"
                    />
                    <ValidateText
                        field="mark"
                        scope="subject_with_mark"
                        :error="errors"
                    />
                </div>
            </div>
            <vs-button type="relief" @click="validationCheck">{{
                $t("add")
            }}</vs-button>
        </form>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
export default {
    name: "SubjectWithMarkForm",
    components: {
        MultiselectCustom,
        ValidateText,
    },
    props: {
        applicantUid: {
            type: String,
            required: true,
        },
        objectForEditSubjectWithMark: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            subject: {
                discipline: "",
                score: "",
                profile: this.applicantUid,
                uid: null,
            },
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
        };
    },
    methods: {
        async saveData() {
            try {
                await this.$vs.loading();

                const newSubject = this.subject?.uid;
                const response = (
                    await this.$http[newSubject ? "patch" : "post"](
                        `admissions/subjects/${
                            newSubject ? newSubject + "/" : ""
                        }`,
                        this.subject
                    )
                ).data;

                this.$emit("setObjectSubjectWithMark", response);
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        validationCheck() {
            return this.$validator
                .validateAll("subject_with_mark")
                .then(async (result) => {
                    if (result) {
                        // Делаю запросы на сохранение и пропускаю клиента на следующий шаг
                        await this.saveData();
                        return true;
                    } else return false;
                });
        },
    },
    created() {
        if (this.objectForEditSubjectWithMark) {
            for (let key in this.subject) {
                this.subject[key] = this.objectForEditSubjectWithMark[key];
            }
        }
    },
};
</script>

<style scoped lang="scss">
</style>
